// src/hooks/usePapConversation.js
//
// Koppeling tussen de PAP-chatwidget en het account. De widget vraagt het actieve
// gesprek op en meldt nieuwe of gewiste gesprekken; wij slaan het actieve id op
// bij de gebruiker en zetten elk gesprek in de gesprekkenlijst.
//
// De callbacks blijven stabiel (refs), anders laadt de widget bij elke render
// opnieuw.
import { useCallback, useEffect, useRef } from 'react';
import { useDoorloopjes } from '../context/DoorloopjesContext';
import { registerAiGesprek } from '../utils/aiGesprekken';

export function usePapConversation() {
  const { getActiveAiSessionId, updateAiSessionId } = useDoorloopjes();

  const updateRef = useRef(updateAiSessionId);
  useEffect(() => {
    updateRef.current = updateAiSessionId;
  }, [updateAiSessionId]);

  const getConversationId = useCallback(async () => getActiveAiSessionId(), [getActiveAiSessionId]);

  const onConversationIdUpdate = useCallback((id) => {
    updateRef.current?.(id);
    registerAiGesprek(id);
  }, []);

  // Nieuw gesprek in de widget, of het gekozen gesprek bestaat niet meer in PAP.
  // Het vorige gesprek blijft in de lijst staan.
  const onConversationReset = useCallback(() => {
    updateRef.current?.(null);
  }, []);

  return { getConversationId, onConversationIdUpdate, onConversationReset };
}
